<template>
  <main class="page">
    <section v-if="loading" class="state state--loading">
      <div class="spinner" aria-label="Loading"></div>
      <p>Preparing your experience...</p>
    </section>

    <section v-else-if="errorMessage" class="state state--error">
      <h1>We hit a snag</h1>
      <p>{{ errorMessage }}</p>
      <p>Please check the link and try again.</p>
    </section>
  </main>
</template>

<script>
import {onMounted, ref} from 'vue'
import {userAuthenticate} from '@/functions/userAuthenticate'

export default {
  name: 'HomeView',
  setup() {
    const loading = ref(true)
    const errorMessage = ref('')

    onMounted(async () => {
      try {
        const redirectUrl = await userAuthenticate()
        window.location.replace(redirectUrl)
      } catch (error) {
        console.error(error)
        errorMessage.value = 'Oops something went wrong. Please check your SMS inbox'
        loading.value = false
      }
    })

    return {
      loading,
      errorMessage
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f9fb;
  color: #1f2933;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  padding: 24px;
}

.state {
  text-align: center;
}

.spinner {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border: 6px solid rgba(31, 41, 51, 0.15);
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.state--error h1 {
  margin-bottom: 8px;
}
</style>
